import { FC } from 'react';

import RectangleNorth from '../../../../../../../assets/icons/shapes/rectangular/rectangular-1.svg?react';
import RectangleSouth from '../../../../../../../assets/icons/shapes/rectangular/rectangular-1-1.svg?react';
import RectangleWest from '../../../../../../../assets/icons/shapes/rectangular/rectangular-1-2.svg?react';
import RectangleEast from '../../../../../../../assets/icons/shapes/rectangular/rectangular-2.svg?react';
import { Himmelretning } from '../../../../../utils/registerEnums';

import { ShapeProps } from './types';

export const Rectangle: FC<ShapeProps> = ({ direction }) => {
  switch (direction) {
    case Himmelretning.Nord:
      return <RectangleNorth />;
    case Himmelretning.Ost:
      return <RectangleEast />;
    case Himmelretning.Sor:
      return <RectangleSouth />;
    case Himmelretning.Vest:
      return <RectangleWest />;

    default:
      return <RectangleNorth />;
  }
};
